module.exports = __webpack_public_path__ + "img/竞赛-3.1d958955.jpg";